module.exports = __webpack_public_path__ + "static/img/githublogo.a74f6a9f.jpg";